import React from "react";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col } from "react-bootstrap";

//Services
import Api from "../../services/api";

//Components
import InputReport from "../../Components/inputReport/inputReport";
import "../../Components/inputReport/inputReport.css";
import MessageTable from "../../Components/messageTable/MessageTable";
import DatePicker from "../../Components/datePicker/datePicker";
import TableList from "../../Components/tableList/TableList";
import FilterBox from "../../Components/filterBox/filterBox";
import Select from "../../Components/select/select";
import ReportButtons from "../../Components/reports/ReportButtons";

//Styles
import styles from "../General/details.module.css";
import "./generalReports.css";
import "../Prelude/prelude.css";
import "../../Components/reports/reports.css";

class reportRefuses extends React.Component {
  state = {
    text: "",
    data: [],
    initialData: [],
    code: null,
    start_date: new Date().toLocaleDateString("pt-BR"),
    end_date: new Date().toLocaleDateString("pt-BR"),
    machine: "",
    item: "",
    loading: false,
    workshifts: [{ value: null, label: "Todos" }],
    workshift: null,
  };

  async componentDidMount() {
    this.getWorkShifts();
  }

  filter = (data, name) => {
    this.setState({ [`${name}`]: data });
  };

  saveText = (data) => {
    const { value, name } = data;
    this.setState({ [`${name}`]: value });
  };

  selectWs = (data) => {
    this.setState({ workshift: data });
  };

  getWorkShifts = () => {
    Api.get("/work-shifts/").then((resp) => {
      if (resp.data.length > 0) {
        let wsPrev = this.state.workshifts;
        resp.data.forEach((element) => {
          wsPrev.push({ value: element.id, label: element.code });
        });
        this.setState({ workshifts: wsPrev });
      }
    });
  };

  filterData = (data, name) => {
    this.setState({ [`${name}`]: data });
  };

  sendData = async () => {
    const params = {
      machine: this.state.machine.trim(),
      item: this.state.item.trim(),
      ws: this.state.workshift,
      dt_ini: this.state.start_date,
      dt_end: this.state.end_date,
    };
    let count = 0;
    for (let p in params) {
      if (params[p]) count++;
    }
    if (count > 0) {
      this.setState({ loading: true });
      await Api.get("/reports/refuses", { params: params })
        .then((resp) => {
          let arr = [];
          if (resp.data.length === 0) {
            this.setState({ render: false });
          } else {
            resp.data.forEach((element) => {
              arr.push({
                Máquina: element.Máquina,
                Ordem: element.Ordem,
                Item: element.Item,
                Operador: element.operador,
                Quantidade: `${element["N° de peças"]}${element.Unidade}`,
                Data: moment(element.Data).format("DD/MM/YYYY"),
                Hora: element.Hora,
                Motivo: element["Motivo de Refugo"],
                Turno: element.Turno,
                Detalhes: element.Detalhes,
              });
            });
            this.setState({ data: arr, render: true, initialData: arr });
            if (this.state.loading) this.setState({ loading: false });
          }
        })
        .catch((err) => {
          alert("Erro de conexão com o servidor");
        });
      await Api.get("/work-shifts/")
        .then((resp) => {
          let arr_codes = [];
          let arr_ids = [];
          resp.data.forEach((element) => {
            arr_codes.push({ value: element.code });
            arr_ids.push({ id: element.id, code: element.code });
          });
          this.setState({ arrayWorkShifts: arr_codes, arr_idcodes: arr_ids });
          if (this.state.loading) this.setState({ loading: false });
        })
        .catch((error) => {
          if (error.response) {
            return alert(
              error.response.data +
                "\n" +
                error.response.status +
                "\n" +
                error.response.headers
            );
          }
        });
    } else {
      alert("Preencha um campo de filtro");
    }
  };

  excelbutton = (event) => {
    if (this.state.data.length === 0) {
      alert("Preencha um campo de filtro");
      event.preventDefault();
    }
  };

  render() {
    let keys = null;
    const row = ({ record }) => {
      const keys = Object.keys(record);
      return (
        <tr key={record.id}>
          {keys.map((key) => (
            <td key={key}>{record[key]}</td>
          ))}
        </tr>
      );
    };

    if (this.state.render) {
      keys = Object.keys(this.state.data[0]);
    }

    return (
      <>
        <FilterBox title="Filtros" spacePadding>
          <Row type="input" className="w-100">
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <InputReport
                name="machine"
                parentCallback={this.saveText}
                title="Máquina"
                focus={true}
              />
            </Col>
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <InputReport
                name="item"
                parentCallback={this.saveText}
                title="Item"
              />
            </Col>
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <DatePicker
                name="Data"
                title="Data Inicial"
                parentCallback={(e) => this.filterData(e, "start_date")}
              />
            </Col>
            <Col lg={2} sm={6} type="input" className="p-1 mb-1">
              <DatePicker
                name="Data"
                title="Data Final"
                parentCallback={(e) => this.filterData(e, "end_date")}
              ></DatePicker>
            </Col>
            <Col
              lg={4}
              sm={12}
              xs={12}
              type="input"
              className="p-1 mb-1 selectFilter"
              id="filterSelect"
            >
              <Select
                label="Turno"
                arrData={this.state.workshifts}
                handleSelect={(e) => {
                  this.selectWs(e);
                }}
              />
            </Col>
          </Row>
          <ReportButtons type="input" handleClick={this.sendData} excelData={this.state.data} surnameFile="refugos"/>
        </FilterBox>

        <div className="filters boxReport">
          {this.state.loading ? (
            <div>
              <div style={{ marginTop: "20vh" }} className={styles.loader}>
                <Spinner variant="success" animation="border" />
                <strong>Carregando...</strong>
              </div>
            </div>
          ) : (
            <>
              {this.state.render ? (
                <div className="TableReport">
                  <TableList data={this.state.data}></TableList>
                </div>
              ) : (
                <div className="TableReport">
                  <MessageTable message={"Sem dados para processar."} />
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default reportRefuses;
